/**
 * Account-wide family tree limits — keep in sync with backend/services/tree_limits.py
 */

export const TREE_LIMIT_BY_PLAN = {
  free: 1,
  family: 3,
  premium: 10,
};

export const PLAN_DISPLAY_NAME = {
  free: 'Free',
  family: 'Family',
  premium: 'Legacy',
};

export function getTreeLimitForPlan(plan) {
  return TREE_LIMIT_BY_PLAN[plan] ?? TREE_LIMIT_BY_PLAN.free;
}

export function getTreeUsageLabel(ownedCount, limit) {
  const n = Math.max(0, Number(ownedCount) || 0);
  const cap = Math.max(1, Number(limit) || 1);
  const unit = cap === 1 ? 'tree' : 'trees';
  return `${n} of ${cap} ${unit} used`;
}

export function getTreeLimitUpgradeMessage(plan, { atLimit = false } = {}) {
  if (!atLimit) return null;
  if (plan === 'free') {
    return 'Your Free plan includes 1 family tree. Upgrade to create more.';
  }
  if (plan === 'family') {
    return 'Your Family plan includes up to 3 family trees. Upgrade to Legacy Archive for more.';
  }
  return 'Legacy Archive supports multiple family archives. You\'ve reached your current tree limit.';
}

export function getTreeLimitHint(plan) {
  if (plan === 'premium') {
    return 'Legacy Archive supports multiple family archives.';
  }
  if (plan === 'family') {
    return 'Your Family plan includes up to 3 family trees.';
  }
  return 'Your Free plan includes 1 family tree.';
}
